import { select, all, call, put, takeEvery, cancel } from 'redux-saga/effects';

import {
  getSession,
  putPrivacySettings,
  graphql,
} from '../../../globals/api/requests';

import actions, {
  TRACKING_TOGGLE_SAVE,
  TRACKING_TOGGLE_SAVE_SUCCESS,
} from '../actions/tracking';

import { pushEvent } from '../../../client/data-layer';

import { promptToast } from '../../../components/toast-container/actions';

export function* saveTrackingSettings({
  settings,
  isLoggedIn,
  showSuccessPrompt,
}) {
  if (isLoggedIn) {
    try {
      yield all(
        Object.entries(settings).map(([key, value]) =>
          call(
            graphql,
            `
              mutation($data: SettingInputType!) {
                updateSetting(data: $data) {
                  success
                }
              }
            `,
            {
              data: {
                setting: key,
                value: value ? '1' : '0',
              },
            }
          )
        )
      );
    } catch (e) {
      yield put(actions.trackingToggleSaveError({ ...settings, error: true }));
      yield cancel();
    }
  }
  try {
    const response = yield call(putPrivacySettings, settings);
    if (response.status !== 200) {
      throw new Error('tracking save failed');
    } else {
      yield put(actions.trackingToggleSaveSuccess(settings, showSuccessPrompt));
    }
  } catch (e) {
    yield put(actions.trackingToggleSaveError({ ...settings, error: true }));
  }
}

export function* trackingSettingsSaved({ showSuccessPrompt }) {
  const sessionData = yield call(getSession);
  window.SESSION_DATA = sessionData;
  const {
    session,
    trackingSettings,
    gaClientId,
    pulseEnvironmentId,
  } = sessionData;

  yield call(
    pushEvent,
    'updateTrackingSettings',
    {
      trackingSettings,
    },
    { eventNameAsKey: false }
  );

  yield put({
    type: 'SESSION_RECEIVE',
    session,
    privacyCookie: trackingSettings,
    clientId: gaClientId,
    pulseEnvironmentId,
  });

  if (showSuccessPrompt) {
    yield put(
      promptToast('success', window.APP_GLOBALS.t('account', 'settings.saved'))
    );
  }
}

export function* userLoggedIn(action) {
  const trackingSettings = yield select(
    state => state.areas.user.tracking.settings
  );

  const tracking = action.me.privacySettings.reduce(
    (settings, setting) => ({
      ...settings,
      [setting.name]: setting.active,
    }),
    {}
  );

  const isEqual = Object.entries(tracking).reduce(
    (equal, [name, value]) => equal && value === trackingSettings[name],
    true
  );

  if (!isEqual) {
    yield put(actions.trackingToggleSave(tracking, true));
  }
}

function* mySaga() {
  yield takeEvery('USER_RECEIVE', userLoggedIn);
  yield takeEvery(TRACKING_TOGGLE_SAVE, saveTrackingSettings);
  yield takeEvery(TRACKING_TOGGLE_SAVE_SUCCESS, trackingSettingsSaved);
}

export default mySaga;
